(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lucid-chips"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucid-chips')) {
    customElements.define(
      'lucid-chips',
      class extends HTMLElement {
        connectedCallback() {
          const list = this.querySelector('.lucid-chips__list');
          const active = list && list.querySelector('.is-active');
          if (list && active) {
            const offset = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
            list.scrollLeft = Math.max(0, offset);
          }

          if (!this.hasAttribute('data-sticky') || !('IntersectionObserver' in window)) return;
          const wrapper = this.closest('.shopify-section');
          if (!wrapper) return;
          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (!entry) return;
              const stuck = entry.intersectionRatio < 1 && entry.boundingClientRect.top <= 1;
              wrapper.classList.toggle('lucid-chips-stuck', stuck);
            },
            { threshold: [1], rootMargin: '-1px 0px 0px 0px' }
          );
          this.observer.observe(wrapper);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
